import MC from "components/Stacker/constants/ModalConstants"

export const createModal = (name) => {
  return {
    type: MC.MODAL_CREATE,
    payload: name,
  }
}

// Req. to pass modalName
// If modalStatus is NOT passed - it will just flip the status
// If modalStatus is PASSED - it will set that respctive status
export const toggleModal = (modalName, modalStatus) => {
  if (typeof modalStatus !== "undefined") {
    return {
      type: modalStatus ? MC.MODAL_SHOW : MC.MODAL_HIDE,
      payload: { modalName },
    }
  }

  return {
    type: MC.MODAL_TOOGLE,
    payload: { modalName, modalStatus },
  }
}

export const destroyModal = (name) => {
  return {
    type: MC.MODAL_DESTROY,
    payload: name,
  }
}
